import { useState } from "react";

export const useListingForm = (initialValues = {}) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    category: "",
    location: null, // shape: { coordinates: [lng, lat], label, ... } or null
    useProfileLocation: true, // default: inherit from profile
    barterFor: [],
    ...initialValues,
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field) => (eOrValue) => {
    const value = eOrValue?.target ? eOrValue.target.value : eOrValue;
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleImageChange = (file) => {
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setImageFile(null);
    setImagePreview(null);
  };

  /**
   * Validate the form. Pass `profileLocation` so we can confirm the user has
   * something to inherit from when useProfileLocation is true.
   */
  const validateForm = (profileLocation = null) => {
    const newErrors = {};

    if (!formData.title.trim()) {
      newErrors.title = "Title is required";
    }

    if (!formData.description.trim()) {
      newErrors.description = "Description is required";
    }

    if (!formData.category || (!formData.category._id && !formData.category)) {
      newErrors.category = "Category is required";
    }

    // Location validation
    if (formData.useProfileLocation) {
      if (!profileLocation || !profileLocation.coordinates) {
        newErrors.location =
          "You don't have a profile location. Set one or pick a custom location.";
      }
    } else {
      if (!formData.location || !Array.isArray(formData.location.coordinates)) {
        newErrors.location = "Location is required";
      }
    }

    if (!imageFile) {
      newErrors.image = "Image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      title: "",
      description: "",
      category: "",
      location: null,
      useProfileLocation: true,
      barterFor: [],
    });
    setImageFile(null);
    setImagePreview(null);
    setErrors({});
  };

  return {
    formData,
    setFormData,
    handleChange,
    imageFile,
    imagePreview,
    handleImageChange,
    removeImage,
    errors,
    setErrors,
    validateForm,
    resetForm,
    isSubmitting,
    setIsSubmitting,
  };
};